import { render, staticRenderFns } from "./suRecord.vue?vue&type=template&id=6b87fc10"
import script from "./suRecord.vue?vue&type=script&lang=js"
export * from "./suRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports